
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Breast_Cancer_TNM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Breast_Cancer_TNM.vue